import React, { useState } from "react";
import Switch from "../../../ShareElements/TextInput/Switch";
import SearchInput from "../../../ShareElements/SearchInput/SearchInput";
import JPATabsGuideDialog from "../../../UserGuide/Components/JPATabsGuideDialog";
import BookmarkedItemsGuide from "../../../UserGuide/Components/BookmarkedItemsGuide";
import { formatDate } from "../../../../../../Helper_functions";

const MainContentHead = (props) => {
  const [TabIds] = useState(["projects-tab", "activities-tab", "jobs-tab"]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    if (Label[0]) {
      return Label[0].label_value;
    }
  };
  const handleSwitchTab = (Id) => {
    if (!props.JPATabsGuideIsOpen) {
      if (!document.getElementById(Id).classList.contains("active")) {
        props.DisableMoreLikeThis();
      }

      if (!document.getElementById(Id).classList.contains("active")) {
        if (
          !document.getElementById("clear-btn").classList.contains("hidden")
        ) {
          document.getElementById("clear-btn").click();
        }
      }
      TabIds.map((Item) => {
        document.getElementById(Item).classList.remove("active");
      });
      document.getElementById(Id).classList.add("active");

      document.getElementById("saved-switch-holder").classList.add("off");

      if (Id === "projects-tab") {
        let TransformValue =
          document.getElementById("home-tab-indicator").style.transform.length;
        if (TransformValue === 0 || TransformValue === 15) {
          document
            .getElementById("top-projects")
            .classList.remove("translate-right");
          document
            .getElementById("top-projects")
            .classList.add("translate-left");
        } else {
          document
            .getElementById("top-projects")
            .classList.remove("translate-left");
          document
            .getElementById("top-projects")
            .classList.add("translate-right");
          setTimeout(() => {
            document
              .getElementById("top-projects")
              .classList.remove("translate-right");
          }, 1500);
        }
        if (window.innerWidth <= 450) {
          document.getElementById("home-tab-indicator").style.transform =
            "translateX(100%)";
        } else {
          document.getElementById("home-tab-indicator").style.transform =
            "translateX(120px)";
        }
        props.ShowProjects();
      } else if (Id === "activities-tab") {
        if (window.innerWidth <= 450) {
          document.getElementById("home-tab-indicator").style.transform =
            "translateX(200%)";
        } else {
          document.getElementById("home-tab-indicator").style.transform =
            "translateX(245px)";
        }
        props.ShowActivities();
        document
          .getElementById("top-activities")
          .classList.add("translate-left");
        setTimeout(() => {
          document
            .getElementById("top-activities")
            .classList.remove("translate-left");
        }, 1500);
      } else {
        document.getElementById("home-tab-indicator").style.transform =
          "translateX(0)";
        props.ShowJobs();
        // currently we don't want to show this animation
        // document.getElementById("top-jobs").classList.add("translate-left");
        // setTimeout(() => {
        //   if (document.getElementById("top-jobs")) {
        //     document
        //       .getElementById("top-jobs")
        //       .classList.remove("translate-left");
        //   }
        // }, 1500);
      }
    }
  };

  const handleSwitchChange = () => {
    let TabId;
    TabIds.map((Item) => {
      if (document.getElementById(Item).classList.contains("active")) {
        TabId = Item;
      }
    });
    let IsSavedOnly = false;
    if (
      !document.getElementById("saved-switch-holder").classList.contains("off")
    ) {
      IsSavedOnly = true;
    }
    if (IsSavedOnly) {
      props.ShowSavedOnly();
    } else {
      handleSwitchTab(TabId);
    }

    props.CatIds.map((CatId) => {
      document.getElementById(CatId).classList.remove("active-category");
    });
    document.getElementById("cat-1").classList.add("active-category");
  };

  const displayTime = (Time) => {
    let Hours = new Date(Time).getUTCHours();
    let Minutes = new Date(Time).getUTCMinutes();
    if (Hours < 10) {
      Hours = "0" + Hours;
    }
    if (Minutes < 10) {
      Minutes = "0" + Minutes;
    }

    return Hours + ":" + Minutes;
  };

  const removeJPAFilter = () => {
    //removing the localstorage item since it's not required anymore and hiding the filter element
    window.localStorage.removeItem("notification_jpa_search_data");
    props.setNotificationJPAFilterIsActive(false);

    //finding the active tab by their className
    let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
    let ActiveTab; // the active tab id
    TabIds.map((Id) => {
      if (document.getElementById(Id).classList.contains("active")) {
        ActiveTab = Id;
      }
    });
    if (ActiveTab === TabIds[0]) {
      props.ShowProjects();
    } else if (ActiveTab === TabIds[1]) {
      props.ShowActivities();
    } else {
      props.ShowJobs();
    }
  };

  const shortenText = (Title) => {
    // mobile
    if (window.innerWidth <= 450) {
      if (Title.length < 35) {
        return Title;
      } else {
        let Short = Title.slice(0, 31) + "...";
        return (
          <>
            {Short}
            <p className="info-popup">{Title}</p>
          </>
        );
      }
    } else {
      // desktop and tablet
      if (Title.length < 70) {
        return Title;
      } else {
        let Short = Title.slice(0, 66) + "...";
        return (
          <>
            {Short}
            <p className="info-popup">{Title}</p>
          </>
        );
      }
    }
  };

  const toggleNextGuide = () => {
    if (props.GuideHasAdditionalStep) {
      props.JumpToStep(2);
    } else {
      props.ToggleSecondGuide(false);
    }
  };

  // bookmarks guide
  const togglePreviousGuide = () => {
    if (props.GuideHasAdditionalStep) {
      props.JumpToStep(2);
    } else {
      props.ToggleSecondGuide();
    }
  };

  const toggleCategorySwitch = (SelectedID) => {
    document.getElementById("saved-switch-holder").classList.add("off");

    props.CatIds.map((ItemID) => {
      document.getElementById(ItemID).classList.remove("active-category");
    });
    document.getElementById(SelectedID).classList.add("active-category");

    let ActiveTab = "jobs-tab";
    TabIds.map((TabId) => {
      if (document.getElementById(TabId).classList.contains("active")) {
        ActiveTab = TabId;
      }
    });

    if (ActiveTab === "jobs-tab") {
      props.ShowJobs();
    } else if (ActiveTab === "projects-tab") {
      props.ShowProjects();
    } else if (ActiveTab === "activities-tab") {
      props.ShowActivities();
    }
  };

  return (
    <React.Fragment>
      {props.JPATabsGuideIsOpen ? <div className="overlay"></div> : null}

      <div className="home-head-top-row">
        {props.UpdateDateTime ? (
          <p className="last-update">
            {translateText("last_update_on")} {formatDate(props.UpdateDateTime)}{" "}
            {translateText("at")} {displayTime(props.UpdateDateTime)}
          </p>
        ) : (
          <p className="last-update">
            {translateText("no_info_available_at_this_time")}
          </p>
        )}
        <SearchInput
          OnChange={() => props.ToggleSearch()}
          Placeholder={translateText("search") + " ..."}
        />
      </div>
      <div className="home-head-bot-row">
        <section className="home-tabs" id="home-tabs">
          {props.JPATabsGuideIsOpen ? (
            <JPATabsGuideDialog
              ToggleNextDialog={() => toggleNextGuide()}
              TogglePreviousDialog={() => props.ToggleSecondGuide()}
              LangData={props.LangData}
              JumpToStep={(Step) => props.JumpToStep(Step)}
              CloseGuide={() => props.CloseGuide()}
              GuideHasAdditionalStep={props.GuideHasAdditionalStep}
            />
          ) : null}
          <span id="home-tab-indicator"></span>
          <div
            className="tab-item active"
            id="jobs-tab"
            onClick={() => handleSwitchTab("jobs-tab")}
          >
            {translateText("top_jobs")}
          </div>
          <div
            className="tab-item"
            id="projects-tab"
            onClick={() => handleSwitchTab("projects-tab")}
          >
            {translateText("top_projects")}
          </div>
          <div
            className="tab-item"
            id="activities-tab"
            onClick={() => handleSwitchTab("activities-tab")}
          >
            {translateText("activities")}
          </div>
        </section>
        <span className="sm-vr-line"></span>
        <section className="categories">
          <span
            id="cat-1"
            className="category-item active-category"
            onClick={() => toggleCategorySwitch("cat-1")}
          >
            {translateText("all")}
            <i className="feather-check"></i>
          </span>
          <span
            id="cat-2"
            className="category-item"
            onClick={() => toggleCategorySwitch("cat-2")}
          >
            {translateText("most_similar")}
            <i className="feather-check"></i>
          </span>
          <span
            id="cat-3"
            className="category-item"
            onClick={() => toggleCategorySwitch("cat-3")}
          >
            {translateText("for_you")}
            <i className="feather-check"></i>
          </span>
        </section>
        {props.BookmarkedItemsGuideIsOpen ? (
          <div className="overlay"></div>
        ) : null}
        <section
          className={
            (props.MoreLikeThisIsActive && !props.LoadingIsShown) ||
            props.NotificationJPAFilterIsActive
              ? "saved-only floated"
              : "saved-only"
          }
          id="saved-only"
        >
          {props.BookmarkedItemsGuideIsOpen ? (
            <BookmarkedItemsGuide
              ToggleNextDialog={() => props.ToggleFourthGuide()}
              TogglePreviousDialog={() => togglePreviousGuide()}
              JumpToStep={(Step) => props.JumpToStep(Step)}
              LangData={props.LangData}
              GuideHasAdditionalStep={props.GuideHasAdditionalStep}
              CloseGuide={() => props.CloseGuide()}
            />
          ) : null}

          {props.BookmarkedItemsGuideIsOpen ? (
            <>
              <div className="shadow-holder"></div>
              <div className="action-disabler"></div>
            </>
          ) : null}
          <p>
            <i className="feather-bookmark"></i>{" "}
            {translateText("saved_items_only")}
          </p>
          <Switch ChangeEvent={() => handleSwitchChange()} Id="saved" />
        </section>
      </div>
      {props.NotificationJPAFilterIsActive ? (
        <div className="notif-search-filter">
          <i className="feather-x" onClick={() => removeJPAFilter()}></i>
          <p>
            {window.innerWidth > 450
              ? translateText("display_all_recommendations")
              : translateText("display_all")}
          </p>
        </div>
      ) : null}
      {props.MoreLikeThisIsActive && !props.LoadingIsShown ? (
        <div className="notif-search-filter">
          <i
            className="feather-x"
            onClick={() => props.CloseMoreLikeThis()}
          ></i>
          <p>
            {shortenText(
              translateText("more_like") + " " + props.MoreLikeThisTitle
            )}
          </p>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default MainContentHead;
